interface EnvConfig {
  apiEndpoint: string;
  s3Bucket: string;
  cognito: {
    region: string;
    userPoolId: string;
    appClientId: string;
    identityPoolId: string;
  };
  apiGateway: {
    name: string;
    id: string;
    region: string;
  };
}

const dev: EnvConfig = {
  apiEndpoint: 'https://api.dev.theyemma.com',
  s3Bucket: 'yemma-uploads-eu-central-1-dev',
  cognito: {
    region: 'eu-central-1',
    userPoolId: 'eu-central-1_WgepPR2go',
    appClientId: '19cmmncausi7kk6aa4v9t5h7vf',
    identityPoolId: 'eu-central-1:45ee2d2e-0e13-4644-8888-2afb9f1b6db8',
  },
  apiGateway: {
    name: 'yemma-api-dev',
    id: '2a2r14d4pk',
    region: 'eu-central-1',
  },
};

const prod: EnvConfig = {
  apiEndpoint: 'https://api.prod.theyemma.com',
  s3Bucket: 'yemma-uploads-eu-central-1-prod',
  cognito: {
    region: 'eu-central-1',
    userPoolId: 'eu-central-1_uqqhvqIvE',
    appClientId: '42bous72gt14s9b3c6uce1md03',
    identityPoolId: 'eu-central-1:d5e69f91-80d0-47ec-9358-5b538909c7d1',
  },
  apiGateway: {
    name: 'yemma-api-prod',
    id: '4f2ofqyi0a',
    region: 'eu-central-1',
  },
};

export const env: EnvConfig =
  import.meta.env.VITE_ENVIRONMENT === 'development' ? dev : prod;
